import React from 'react';
import './header.css';
import Facebook from '../../svg/Facebook';
import Instagram from '../../svg/Instagram';
import WhatsApp from '../../svg/WhatsApp';
import LinkedIn from '../../svg/LinkedIn';
import GitHub from '../../svg/GitHub';
import Particles from 'react-particles-js';

export default function Header() {
    return (
        <div className="header" id='home'>
            <div className="container">
                <div className="section-flex">
                    <div className="section-left">
                        <div className="content">
                            <h1 className="titlehead">{"<"}Hii{">"}  </h1>
                            <h1 className="title">This is <span>Ashish </span></h1>
                            <h2 className="subtitle">Software Engineer</h2>
                            <p className="para"> <span>{"<p>"}</span>  I am an experienced developer based in Mumbai who focus on writing clean,elegant and efficient code. I'm  available for Freelance work and projects. <span> {"<p> "}</span>  </p>

                            <div className="content-social header-social">
                                <div className="social-flex">
                                            <a href="https://github.com/Ashish8689" target="_blank" rel="noreferrer">
                                                <GitHub className={"i"} />
                                            </a>

                                            <a href="https://www.facebook.com/profile.php?id=100004838256907" target="_blank" rel="noreferrer">
                                                <Facebook className={"i"} />
                                            </a>
                                    
                                            <a href="https://www.instagram.com/ashishgupta9394/" target="_blank" rel="noreferrer">
                                                <Instagram className={"i"} />
                                            </a>
                                    
                                            <a href="https://wa.me/+918689868867" target="_blank" rel="noreferrer">
                                                <WhatsApp className={"i"} />
                                            </a>

                                            <a href="https://www.linkedin.com/in/ashish-gupta8689" target="_blank" rel="noreferrer">
                                                <LinkedIn className={"i"} />
                                            </a>

                                </div>{/* social flex end */}
                            </div>

                            

                            <div className="button-container">
                                <a href="tel: 8689868867" className="button active">Hire Me</a>
                                <a href={process.env.PUBLIC_URL + '/image/CV_ASHISH_GUPTA.pdf'} download className="button">Download CV</a>
                            </div>
                        </div>
                    </div>
                    <div className="section-right">
                          <div className="img-container">
                              <img src={process.env.PUBLIC_URL + '/image/a1.png'} alt="Ashish Gupta"/>
                          </div>
                    </div>
                </div>

                <div className="header-social">
                     <div className="social-flex">
                                <a href="https://www.facebook.com/profile.php?id=100004838256907" target="_blank" rel="noreferrer">
                                    <Facebook className={"i"} />
                                </a>
                        
                                <a href="https://www.instagram.com/ashishgupta9394/" target="_blank" rel="noreferrer">
                                    <Instagram className={"i"} />
                                </a>
                        
                                <a href="https://wa.me/+918689868867" target="_blank" rel="noreferrer">
                                    <WhatsApp className={"i"} />
                                </a>

                                <a href="https://www.linkedin.com/in/ashish-gupta8689" target="_blank" rel="noreferrer">
                                    <LinkedIn className={"i"} />
                                </a>

                      </div>{/* social flex end */}
                </div>


                <div className="scroll-down-container">
                    <h6>Scroll down</h6>
                </div>
            </div>    


            {/* *************  Particles js  **************** */}

            <Particles id="particles-js"
            params={{
                particles: {
                    number: {
                        value: 60,
                        density: {
                            enable: true,
                            value_area: 1000
                        }
                    },
                    color: {
                    value: ["#BD10E0","#B8E986","#50E3C2","#7a57d1","#E86363"]
                    },
                    opacity: {
                        value: 0.4,
                        anim: {
                            enable: true
                        }
                    },
                    size: {
                        value: 7,
                        random: true,
                        anim: {
                            enable: true,
                            speed: 3
                        }
                    },
                    line_linked: {
                        enable: false
                    },
                    move: {
                        speed: 1
                    }
                 }    
            }}    
        />

        {/* *************  Animation overlay   ********************** */}

        <div className="box-fill"></div>
        <div className="box-mini-bar"></div>

        <img src={process.env.PUBLIC_URL + '/image/icons/wave.png'} className="wave" alt="Ashish Gupta"/>
        <img src={process.env.PUBLIC_URL + '/image/icons/wave.png'} className="wave wave2" alt="Ashish Gupta"/>

        <img src={process.env.PUBLIC_URL + '/image/icons/triangle.png'} className="triangle" alt="Ashish Gupta"/>
     </div>
    )
}
